import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

import TipContent from './tip-content/TipContent'
import { ClientProposalOwnerActionEnum } from '../../../../../lib/graphql'

const Tips = ({
  className,
  clientProposalOwnerCurrentAction,
}: {
  className?: string
  clientProposalOwnerCurrentAction: ClientProposalOwnerActionEnum
}) => {
  return (
    <div className={clsx(s.container, className)}>
      <TipContent
        clientProposalOwnerCurrentAction={clientProposalOwnerCurrentAction}
      />
    </div>
  )
}

export default Tips
